export const createWorker = () => new Worker(new URL(
/* webpackChunkName: "pv.worker", webpackPreload: true */
'./worker.ts', import.meta.url), { type: 'module' });
